module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"commentTip":"Your comment (press Enter to send)","bindToTimestamp":"Attach to timestamp","bindToAnswer":"Attach to answer","send":"Submit"}}')
  delete Component.options._Ctor
}
